exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unsubscribe{text-align:center;padding:10px 0}.unsubscribe .error{color:red}.unsubscribe .waiting .spinnerWrapper{left:50%;width:40px;height:40px;overflow:hidden;position:relative;margin-left:-20px}.unsubscribe .waiting .spinnerWrapper .blackSpinner>div{background-color:#000!important}.unsubscribe .optIns{max-width:400px;margin-left:auto;margin-right:auto;text-align:left}.unsubscribe .optIns .btn-container{margin:10px 0;text-align:center}.unsubscribe .optIns .btn-container .saved{font-size:20px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/unsubscribe.scss
// module id = 1322
// module chunks = 2